import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["render", "data", "onChange", "value"];
import PropTypes from 'prop-types';
import React from 'react';
import { iterate } from '@jd/jmtd-tools/es/tree';
import ErrorBoundary from '../ErrorBoundary';
import BasicCheckboxGroup from '../BasicCheckboxGroup';
import ConfigConsumer from '../ConfigConsumer';
export default function CheckboxGroup(_ref) {
  var _data$;

  var render = _ref.render,
      data = _ref.data,
      onChange = _ref.onChange,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var valueSet = new Set(value);
  var withLabel = data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.data;
  var withMore = false;

  if (withLabel) {
    withMore = _toConsumableArray(iterate(data, {
      childrenName: 'data'
    })).filter(function (_ref2) {
      var node = _ref2.node;
      return node.more || node.autoCollapse;
    }).length !== 0;
  }

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref3) {
    var locale = _ref3.locale;
    return render({
      data: data,
      value: value,
      isChecked: function isChecked(v) {
        return valueSet.has(v);
      },
      withLabel: withLabel,
      withMore: withMore,
      update: onChange,
      locale: locale
    }, otherProps);
  }));
}
CheckboxGroup.propTypes = {
  id: PropTypes.string,
  value: PropTypes.any,
  render: PropTypes.func,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  showLength: PropTypes.bool,
  showReset: PropTypes.bool,
  showClear: PropTypes.bool,
  showAll: PropTypes.bool,
  resetValue: PropTypes.array,
  separator: PropTypes.bool
};
CheckboxGroup.defaultProps = {
  id: null,
  render: BasicCheckboxGroup,
  value: [],
  onChange: function onChange() {},
  className: '',
  size: null,
  maxLength: null,
  minLength: null,
  showLength: false,
  showReset: false,
  showClear: false,
  showAll: false,
  resetValue: undefined,
  separator: null
};